<template>
    <div class="header">
        <nav class="header-navbar navbar-expand-md navbar navbar-with-menu navbar-without-dd-arrow navbar-static-top navbar-light navbar-brand-center"
            data-nav="brand-center">
            <div class="navbar-wrapper">
                <div class="navbar-container content">
                    <div class="collapse navbar-collapse" id="navbar-mobile">
                        <ul class="nav navbar-nav mr-auto float-left">
                            <li class="nav-item d-none d-md-block">
                                <router-link :to="{ name: 'Dashboard'}" class="navbar-brand" href="">
                                    <img class="brand-logo mr-1 d-inline-block" alt="modern admin logo" src="@/app-assets/images/ico/favicon.png" width="30" height="30">
                                    <h3 class="brand-text d-inline-block">
                                        <strong>gb_agent</strong>
                                    </h3>
                                </router-link>
                            </li>
                        </ul>
                        <ul class="nav navbar-nav float-right">
                            <li class="dropdown dropdown-user nav-item">
                                <a class="nav-link nav-link-label" href="#" data-toggle="dropdown">
                                    <i class="ficon ft-message-circle"></i>
                                    <span v-bind:class="{'badge badge-pill badge-default badge-danger badge-default badge-up badge-glow': AllRooms.running.length + AllRooms.late.length >= userSettings.max_rooms, 'badge badge-pill badge-default badge-success badge-default badge-up badge-glow': AllRooms.running.length + AllRooms.late.length < userSettings.max_rooms}">{{AllRooms.running.length + AllRooms.late.length}}</span>
                                </a>
                            </li>
                            <li class="dropdown dropdown-user nav-item">
                                <b-dropdown menu-class="no-transition" right no-caret variant="white" class="user-menu">
                                <template slot="button-content">
                                    <a class="dropdown-toggle nav-link dropdown-user-link" href="#" data-toggle="dropdown">
                                        <span class="mr-1">
                                            <span class="user-name text-bold-700" v-if="userSettings.first_name && userSettings.last_name">{{userSettings.first_name + ' ' + userSettings.last_name}}</span>
                                        </span>
                                        <span v-bind:class="{'avatar avatar-away' : userSettings.paused, 'avatar avatar-online' : !userSettings.paused}">
                                            <img :src="userSettings.avatar" alt="avatar" v-if="userSettings.avatar">
                                            <img src="@/app-assets/images/user-guest.png" alt="avatar" v-else>
                                            <i></i>
                                        </span>
                                    </a>
                                </template>
                                <b-dropdown-item v-if="!userSettings.paused " v-on:click="togglePause()"><i class="ft-sunset"></i>Se mettre en pause</b-dropdown-item>
                                <b-dropdown-item v-if="userSettings.paused" v-on:click="togglePause()"><i class="ft-sunset"></i>Revenir de pause</b-dropdown-item>
                                <b-dropdown-item v-if="userSettings.kind == 'supervisor'"><router-link :to="{ name: 'SupervisorStatistics'}"><i class="ft-bar-chart"></i> Statistiques</router-link></b-dropdown-item>
                                <b-dropdown-item v-if="userSettings.kind == 'agent'"><router-link :to="{ name: 'Statistics'}"><i class="ft-bar-chart"></i> Statistiques</router-link></b-dropdown-item>
                                <b-dropdown-item v-if="userSettings.kind == 'supervisor'" href="/admin" target="_blank"><i class="ft-user"></i>Admin</b-dropdown-item>
                                <b-dropdown-item v-if="userSettings.kind == 'supervisor'">
                                    <router-link :to="{ name: 'parameters'}">
                                        <i class="ft-settings"></i>
                                        Paramètres
                                    </router-link>
                                </b-dropdown-item>
                                <b-dropdown-item v-if="userSettings.kind == 'agent'">
                                    <router-link :to="{ name: 'Settings'}">
                                        <i class="ft-settings"></i>
                                        Paramètres
                                    </router-link>
                                </b-dropdown-item>
                                <b-dropdown-item v-b-modal.modal-logout><i class="ft-log-out"></i> Déconnexion</b-dropdown-item>
                                </b-dropdown>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <b-modal id="modal-logout" ref="modal-logout" class="html-header-footer">
                <div slot="modal-footer">
                </div>
                <div slot="modal-header">
                </div>
                <div class="modal-content p-3 text-center">
                    <h3>
                    <strong>Souhaitez-vous vous déconnecter?</strong>
                    </h3>
                    <div class="text-center mt-5">
                        <button type="button" class="btn btn-outline-dark round mr-1" v-on:click="hideModal('modal-logout')">Non</button>
                        <button type="button" class="btn btn-info round" v-on:click="doLogout()">Oui</button>
                    </div>
                </div>
            </b-modal>
        </nav>
        <div class="header-navbar navbar-expand-sm navbar navbar-horizontal navbar-static navbar-dark navbar-without-dd-arrow navbar-shadow navbar-brand-center" role="navigation" data-menu="menu-wrapper" data-nav="brand-center">
            <div class="navbar-container main-menu-content" data-menu="menu-container">
                <div class="px-1">
                    <div class="row align-items-center py-1 text-white text-center">
                        <div class="col-lg-3 col-12">
                        <h6 class="mt-1 text-muted">Discussions prises</h6>
                        <h5>{{HeaderStats.running_count}}</h5>
                        </div>
                        <div class="col-lg-3 col-12">
                        <h6 class="mt-1 text-muted">Temps d'attente</h6>
                        <h5>{{ new Date((HeaderStats.average_waiting*1000)).toLocaleTimeString('en-GB', {timeZone: 'UTC'}) }}</h5>
                        </div>
                        <div class="col-lg-3 col-12">
                        <h6 class="mt-1 text-muted">Temps de conversation</h6>
                        <h5>{{ new Date((HeaderStats.average_running*1000)).toLocaleTimeString('en-GB', {timeZone: 'UTC'}) }}</h5>
                        </div>
                        <div class="col-lg-3 col-12">
                        <h6 class="mt-1 text-muted">Satisfaction client</h6>
                        <h5>{{HeaderStats.average_sat}}%</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  computed: {
    userSettings () {
      return this.$store.getters.getOwnSettings
    },
    AllRooms () {
      return this.$store.getters.getAllRooms
    },
    HeaderStats () {
      return this.$store.getters.getHeaderStats
    }
  },
  methods: {
    togglePause () {
      this.$socket.togglePause()
    },
    hideModal (modal, followupModal) {
      this.$refs[modal].hide()
      if (typeof followupModal !== 'undefined') {
        this.$refs[followupModal].show()
      }
    },
    doLogout () {
      this.$socket.logout()
      this.hideModal('modal-logout')
    }
  }
}
</script>
